<template>
<div>
    <div>
        <b-row class="mt-4 neu-cards-quiz-ctn history-options-block">
            <clinic-history-quiz-block v-for="block in blocks" :key="block.id" :id="block.id" :title="block.title" :action="block.action" :iconSize="block.iconSize" :blockIdSelected="blockIdSelected" :completed="isCompleted(block.id)" />
        </b-row>
        <clinic-history-quiz-form v-for="item in questionsAndAnswers" :key="item.id" :questionId="item.id" @elementSelected="processElementSelected(item, $event)" @inputSelected="item.healthVarValue = $event; item.answersSelected = []" :question="item.question" :answers="item.answers" :answerVarName="item.answerVarName" 
        :healthVarValue="item.healthVarValue" :answersSelected="item.answersSelected" :inputType="item.inputType" :quizAnswersColumnsAnchor="getQuizAnswersColumnsAnchor(item.answerVarName)" :dontKnowAnswerTitle="dontKnowAnswerTitle(item)" :showDontKnowAnswer="showDontKnowAnswer(item)" :isCompleted="currentBlockIsCompleted" />
        <div v-if="blockIdSelected" class="save-quiz-btn my-4">
            <base-button v-if="!readOnly" @click="saveQuizData">{{saveQuizBtnText}}</base-button>
        </div>
        <base-dialog v-model="showDialogMedicalEvaluation" :content="$t('quizDialog.completeMedicalEvaluation')" :okBtnText="$t('yes')" :cancelBtnText="$t('no')" :okFn="() => {showDialogMedicalEvaluation = false; blockIdSelected = nextBlock[blockIdSelected]; loadClinicBlock(true)}" :cancelFn="() => {showDialogMedicalEvaluation = false; quizCompleted()}"></base-dialog>
    </div>
</div>
</template>

<script>
import ClinicHistoryQuizBlock from '@/components/views/clinicHistory/quiz/ClinicHistoryQuizBlock'
import ClinicHistoryQuizForm from '@/components/views/clinicHistory/quiz/ClinicHistoryQuizForm'
import BaseButton from '@/components/base/buttons/BaseButton'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import BaseDialog from '@/components/base/BaseDialog'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'
import { HEALTH_VARS, FEEDING_HABITS, MOOD_AND_HABITS, HISTORY_AND_DISEASES, MEDICAL_EVALUATION, BLOOD_TYPE, BLOOD_PRESSURE, HIGH_BLOOD_PRESSURE, LOW_BLOOD_PRESSURE, QUIZ_TYPES, getQuizNameByType, MOOD_LEVEL, showDontKnowAnswerByQuestionId, BLOOD_PRESSURE_QUIZ, getAllQuizTypesIds, HEALTH_VARS_PATH, CHRONIC_DISEASE_QUIZ, DISEASES_RELATIONSHIP_QUIZ, ANALYTICS_HIGH_LEVEL } from '@/constants/clinicHistory'

export default {
    components: {
        ClinicHistoryQuizBlock,
        ClinicHistoryQuizForm,
        BaseButton,
        BaseDialog
    },
    props: {
    },
    data () {
        return {
            blockIdSelected: null,
            questionsAndAnswers: [],
            nextBlock: {
                healthVars: FEEDING_HABITS,
                feedingHabits: MOOD_AND_HABITS,
                moodAndHabits: HISTORY_AND_DISEASES,
                historyAndDiseases: MEDICAL_EVALUATION
            },
            healthVars: [],
            feedingHabits: [],
            moodAndHabits: [],
            historyAndDiseases: [],
            medicalEvaluation: [],
            completedQuizs: [],
            showDialogMedicalEvaluation: false,
            HEALTH_VARS_PATH
        }
    },
    mixins: [clinicHistoryMixin],
    created () {
        ClinicHistoryRepository().getCompletedQuizIds().then(response => {
            this.completedQuizs = response.data.data.map(id => getQuizNameByType(id))
            let startBlock = this.completedQuizs.length === 5 || this.completedQuizs.length === 0 ? HEALTH_VARS : getQuizNameByType(getAllQuizTypesIds().filter(id => response.data.data.indexOf(id) < 0)[0])
            this.blockIdSelected = startBlock
            this.loadClinicBlock()
        })
    },
    methods: {
        processElementSelected (item, elementSelected) {
            if (!item.multipleAnswers) {
                const defaultValue = [{answerId: elementSelected.answerId, clinicHistoryValue: elementSelected.clinicHistoryValue, emptyValue: elementSelected.emptyValue}]
                item.answersSelected = item.answersSelected.some(answer => answer.emptyValue === true) ? defaultValue : item.answersSelected.some(answer => answer.answerId === elementSelected.answerId) ? item.answersSelected.filter(answer => answer.answerId !== elementSelected.answerId) : defaultValue
            } else {
                if (elementSelected.emptyValue) {
                    item.answersSelected = [{answerId: elementSelected.answerId, clinicHistoryValue: null, emptyValue: elementSelected.emptyValue}]
                } else if (item.answersSelected.some(answer => answer.answerId === elementSelected.answerId)) {
                    item.answersSelected = item.answersSelected.filter(answer => answer.answerId !== elementSelected.answerId)
                } else {
                    item.answersSelected = item.answersSelected.filter(answer => !answer.emptyValue)
                    item.answersSelected.push(elementSelected)
                }
            }
        },
        getQuizAnswersColumnsAnchor (answerName) {
            return answerName === BLOOD_TYPE ? 1 : answerName === MOOD_LEVEL ? 2 : null
        },
        saveQuizData () {
            if (this.questionsAndAnswers.some(item => item.answers.length > 0 ? item.answersSelected.length === 0 : (!item.answersSelected.some(answer => answer.emptyValue) && !item.healthVarValue))) {
                this.$store.dispatch('showInfoAlert', this.$t('mustFillAllData'))
                return
            } else if (this.blockIdSelected === MEDICAL_EVALUATION && this.questionsAndAnswers.some(item => ((item.answerVarName === HIGH_BLOOD_PRESSURE || item.answerVarName === LOW_BLOOD_PRESSURE) && item.healthVarValue)) && this.questionsAndAnswers.some(item => ((item.answerVarName === HIGH_BLOOD_PRESSURE || item.answerVarName === LOW_BLOOD_PRESSURE) && !item.healthVarValue))) {
                this.$store.dispatch('showInfoAlert', this.$t('mustFillQuizPressureData'))
                return
            }
            ClinicHistoryRepository().saveQuiz(this.processQuizToSave()).then(response => {
                if (!response.data.data) {
                    this.$store.dispatch('showDangerAlert', this.$t('httpRequestDefaultError'))
                    return
                }
                if (!this.completedQuizs.some(item => item === this.blockIdSelected)) {
                    this.completedQuizs.push(this.blockIdSelected)
                }
                this.blocks.find(item => item.id === this.blockIdSelected).completed = true
                if (this.blockIdSelected === HISTORY_AND_DISEASES) {
                    this.showDialogMedicalEvaluation = true
                } else if (this.blockIdSelected === MEDICAL_EVALUATION) {
                    this.quizCompleted()
                } else {
                    this.blockIdSelected = this.nextBlock[this.blockIdSelected]
                    this.loadClinicBlock()
                }
            })
        },
        processQuizToSave () {
            let values = []
            let presureVars = this.questionsAndAnswers.filter(item => item.answerVarName && item.answerVarName.indexOf(BLOOD_PRESSURE_QUIZ) > -1 && item.healthVarValue)
            if (presureVars.length > 0) {
                this.questionsAndAnswers = this.questionsAndAnswers.filter(item => item.answerVarName.indexOf(BLOOD_PRESSURE_QUIZ) === -1)
                let highBloodPresure = presureVars.find(item => item.answerVarName === HIGH_BLOOD_PRESSURE).healthVarValue
                let lowBloodPresure = presureVars.find(item => item.answerVarName === LOW_BLOOD_PRESSURE).healthVarValue
                values.push({answerVarName: BLOOD_PRESSURE, answersSelected: null, historyVarValue: `${highBloodPresure}/${lowBloodPresure}`, questionId: null})
            }
            values = values.concat(this.questionsAndAnswers.map(item => {
                return {answerVarName: item.answerVarName, answersSelected: item.answers.length > 0 && item.answersSelected.some(answer => !answer.emptyValue) ? item.answersSelected.filter(answer => !answer.emptyValue) : null, historyVarValue: item.answers.length === 0 ? item.healthVarValue : null, questionId: item.id}
            }))
            return { quizTypeId: QUIZ_TYPES[this.blockIdSelected], data: values }
        },
        loadClinicBlock (scrollIntoAnswers) {
            if (this[this.blockIdSelected].length > 0) {
                this.questionsAndAnswers = this[this.blockIdSelected]
                setTimeout(() => {
                    window.scrollTo({ top: scrollIntoAnswers ? document.getElementsByClassName('neu-card-questions-and-answers')[0].offsetTop : 0, behavior: 'smooth' })
                }, 100)
            } else {
                ClinicHistoryRepository().getQuiz(QUIZ_TYPES[this.blockIdSelected]).then(response => {
                    this.questionsAndAnswers = response.data.data.map(item => {
                        return {id: item.question.value, question: this.$i18nHelpers.normalize(item.question.name), answerVarName: item.answerVarName, answers: item.answers, healthVarValue: item.healthVarValue ? item.healthVarValue : undefined, answersSelected: item.answersSelected, multipleAnswers: item.multipleAnswer}
                    })
                    this[this.blockIdSelected] = this.questionsAndAnswers
                    setTimeout(() => {
                        window.scrollTo({ top: scrollIntoAnswers ? document.getElementsByClassName('neu-card-questions-and-answers')[0].offsetTop : 0, behavior: 'smooth' })
                    }, 100)
                })
            }
        },
        showDontKnowAnswer (item) {
            if (this.currentBlockIsCompleted && item.answers.length === 0 && !item.healthVarValue) {
                return true
            }
            return item.answerVarName === BLOOD_TYPE || item.answerVarName === MOOD_LEVEL || showDontKnowAnswerByQuestionId(item.id) ? (item.answersSelected.length === 0 || (item.answersSelected.length === 1 && item.answersSelected.some(answer => answer.emptyValue === true))) : item.answers.length === 0 && !item.healthVarValue
        },
        dontKnowAnswerTitle (item) {
            return item.answerVarName === CHRONIC_DISEASE_QUIZ || item.answerVarName === DISEASES_RELATIONSHIP_QUIZ || item.answerVarName === MOOD_LEVEL || item.id === ANALYTICS_HIGH_LEVEL ? this.$t('noneOfTheAbove') : undefined
        },
        isCompleted (blockId) {
            return this.completedQuizs.some(item => item === blockId)
        },
        quizCompleted () {
            this.$router.push({name: 'clinicHistoryMenu'})
        },
        backAction () {
            this.goToSection(HEALTH_VARS_PATH)
        },
        blockSelected (blockId) {
            this.blockIdSelected = blockId
            this.loadClinicBlock(true)
        }
    },
    computed: {
        currentBlockIsCompleted () {
            return this.completedQuizs.some(item => item === this.blockIdSelected)
        },
        saveQuizBtnText () {
            return this.blockIdSelected === MEDICAL_EVALUATION ? this.$t('finish') : this.$t('continue')
        },
        readOnly () {
            return !this.$store.getters['session/userIsPatient'] || this.historyReadOnly
        },
        blocks () {
            let _this = this
            return [
                {
                    id: HEALTH_VARS,
                    title: `${this.$t('healthyVars')}`,
                    action () {
                        _this.blockSelected(HEALTH_VARS)
                    }
                },
                {
                    id: FEEDING_HABITS,
                    title: `${this.$t('feedingHabits')}`,
                    action () {
                        _this.blockSelected(FEEDING_HABITS)
                    }
                },
                {
                    id: MOOD_AND_HABITS,
                    title: `${this.$t('moodAndHabits')}`,
                    action () {
                        _this.blockSelected(MOOD_AND_HABITS)
                    }
                },
                {
                    id: HISTORY_AND_DISEASES,
                    title: `${this.$uiHelpers.isMobile ? this.$t('historyAndDiseasesReduced') : this.$t('historyAndDiseases')}`,
                    action () {
                        _this.blockSelected(HISTORY_AND_DISEASES)
                    }
                },
                {
                    id: MEDICAL_EVALUATION,
                    title: `${this.$t('medicalEvaluation')}`,
                    action () {
                        _this.blockSelected(MEDICAL_EVALUATION)
                    }
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.history-options-block {
    justify-content: center;
}
.save-quiz-btn {
    text-align: center;
}
.neu-cards-quiz-ctn {
//   @include mobile {
//     padding: {
//       left: 2rem;
//       right: 2rem;
//     }
//   }
  > div {
    &:not(:last-child) {
      @include screen-lg-grid {
        margin-right: 2rem;
      }
    }
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/clinicHistory/quiz/ClinicHistoryQuiz.vue